import React, { useEffect, useState } from "react";
import { portalApi } from "@/lib/portalApi";

export default function PortalSmtpPage() {
  const [form, setForm] = useState({
    host: "",
    port: 587,
    username: "",
    password: "",
    from_email: "",
    from_name: "IT-Patrol",
  });
  const [passwordSet, setPasswordSet] = useState(false);
  const [configured, setConfigured] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    portalApi.smtp
      .show()
      .then((data) => {
        const s = data.smtp_setting;
        setForm({
          host: s.host || "",
          port: s.port || 587,
          username: s.username || "",
          password: "",
          from_email: s.from_email || "",
          from_name: s.from_name || "IT-Patrol",
        });
        setPasswordSet(s.password_set);
        setConfigured(s.configured);
      })
      .catch((err) => setError(err.message));
  }, []);

  function setField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function onSave(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    setOk("");
    try {
      const payload = { ...form, port: Number(form.port) };
      if (!payload.password) delete payload.password;
      const data = await portalApi.smtp.update(payload);
      setPasswordSet(data.smtp_setting.password_set);
      setConfigured(data.smtp_setting.configured);
      setForm((prev) => ({ ...prev, password: "" }));
      setOk("SMTP settings saved.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onTest() {
    setBusy(true);
    setError("");
    setOk("");
    try {
      const data = await portalApi.smtp.test();
      setOk(data.message || "Test sent.");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <h1>SMTP settings</h1>
      <p className="muted">
        Credentials are stored encrypted. {configured ? "Configuration looks complete." : "Fill all fields to send campaigns."}
        {passwordSet ? " Password is set." : ""}
      </p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}
      {ok && <div className="portal-alert portal-alert--ok">{ok}</div>}

      <div className="portal-card">
        <form className="portal-form" onSubmit={onSave}>
          <label>
            Host
            <input required value={form.host} onChange={(e) => setField("host", e.target.value)} placeholder="smtp.example.com" />
          </label>
          <label>
            Port
            <input type="number" required value={form.port} onChange={(e) => setField("port", e.target.value)} />
          </label>
          <label>
            Username
            <input required value={form.username} onChange={(e) => setField("username", e.target.value)} autoComplete="off" />
          </label>
          <label>
            Password {passwordSet ? "(leave blank to keep)" : ""}
            <input
              type="password"
              value={form.password}
              onChange={(e) => setField("password", e.target.value)}
              autoComplete="new-password"
              placeholder={passwordSet ? "••••••••" : ""}
            />
          </label>
          <label>
            From email
            <input
              type="email"
              required
              value={form.from_email}
              onChange={(e) => setField("from_email", e.target.value)}
            />
          </label>
          <label>
            From name
            <input value={form.from_name} onChange={(e) => setField("from_name", e.target.value)} />
          </label>
          <div className="portal-actions">
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Saving…" : "Save"}
            </button>
            <button className="btn btn--ghost" type="button" disabled={busy || !configured} onClick={onTest}>
              Send test email
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
